













































































import {Vue, Prop, Component, Watch} from 'vue-property-decorator';
import { getPersianDate } from '@/util/utils';
import { LetterTrailWithAttachments } from '../../../../../store/models/Letter/LetterTrailWithAttachment';
import * as dateConverter from '@/util/dateConverter';
import { DateBaseOnCurrentTimeConverter } from '@/util/dateConverter';
import * as letterService from '@/store/Services/letterServices';
import LetterTrailNodeCommentMobile from './LetterTrailNodeCommentMobile/LetterTrailNodeCommentMobile.vue';
import store from '@/store';

@Component({
    name:'LetterTrailTreeNodeMobile',
    components: {LetterTrailNodeCommentMobile}
})
export default class LetterTrailTreeNodeMobile extends Vue {
   
    @Prop() nodeData?: LetterTrailWithAttachments;
    @Prop() currentPossession?: string;
    isHide = true;
    isLoading=false;
    @Prop() isHideProp?: boolean;
    @Watch('isHideProp')
    onIsHidePropChanged(newVal: boolean , oldVal: boolean){
        
        this.isHide = newVal;
    }
    shallShowComment = false;
    @Prop() serverTime?: string;
    @Prop() isRoot?: boolean;
    get isOpened(){
        //console.log("test");
        //console.log(this.nodeData);
        //console.log(this.nodeData);
        
        if(this.nodeData === undefined) return false;
        //console.log(getPersianDate(this.nodeData.sendTime,"dddd dd MMMM"));
        if(this.nodeData.openTime === null)
            return false;
        else
            return true;
    }

    toggleNode(){
        
        this.isHide = !this.isHide;

    }
    
    

    toggleComment(){
        this.shallShowComment = !this.shallShowComment;

    }

    get timeStr(){
        if(!this.nodeData) return '';
        if(!this.serverTime)return '';
        const dateConverter = new  DateBaseOnCurrentTimeConverter();
        return   dateConverter.getDateString(new Date(this.nodeData.sendTime.substring(0,this.nodeData.sendTime.length -1)),this.serverTime)
    }

    get isInterCompany(){
        if(!this.nodeData) return false;
        return !this.isRoot && this.nodeData.isOwnerCompanyAndIsAPeer
    }

    get isOpen(){
        if(!this.nodeData) return false;
        return !this.isRoot && !this.nodeData.isOwnerCompanyAndIsAPeer && this.nodeData.openTime && !this.nodeData.isClosed && !this.isDraft

    }

    get isNotOpen(){
        if(!this.nodeData) return false;
        return !this.isRoot && !this.nodeData.isOwnerCompanyAndIsAPeer && !this.nodeData.openTime && !this.nodeData.isClosed && !this.isDraft

    }

    get isClosed(){
        if(!this.nodeData) return false;
        return !this.isRoot && !this.nodeData.isOwnerCompanyAndIsAPeer && this.nodeData.isClosed && !this.isDraft
    }

    get isDraft(){
        if(!this.nodeData) return false;
        return this.nodeData.isDraft;
    }

    isRemoteTrailGet = false;
    async getRemotLetterTrail(){
        if(!this.nodeData)return;
        this.isRemoteTrailGet = true;
        const ownerId = store.state.ownerId;
        try {
            this.isLoading=true;
            const result =  await letterService.GetRemoteLetterTrail(this.nodeData.possessionId,ownerId);    
            if(!result)return;
            if(this.nodeData.isSender){
                // this.isHide=false;
                store.state.eventHub.$emit("remote-inquiry",result,this.nodeData.possessionId);
            }else{
                // this.isHide=false;
                this.nodeData.recievers.push(result);
                this.toggleComment();
                this.toggleNode();
            }
        } catch (error) {
            console.log(error)
        }finally{
            this.isLoading=false;
        }
    }

    isEmailOk = false;
    isLoadingEmailStatus = false;
    async getEmailStatus(){
        this.isLoadingEmailStatus = true;
        if(!this.nodeData)return;
        const mailState =  await letterService.getEmailStatus(this.nodeData.emailReference);
        this.isLoadingEmailStatus = false;
        if(mailState === 3)
            this.isEmailOk = true;
    }
    isTelegramOk = false;
    isLoadingTelegramStatus = false;
    async getTelegramStatus(){
        this.isLoadingTelegramStatus = true;
        if(!this.nodeData)return;
        const telegramState =  await letterService.getTelegramStatus(this.nodeData.messagingAppReference);
        this.isLoadingTelegramStatus = false;
        if(telegramState === 3)
            this.isTelegramOk = true;
    }

    
    

}

